import { Box, FormControl, Typography } from '@mui/material';
import { styles } from './Questionnaire.styles';
import { useFormContext, useFormState } from 'react-hook-form';
import { SelectButton } from './SelectButton';
import { useMemo } from 'react';

type SelectProps = {
  name: string;
  values?: string[];
  multi?: boolean;
};

export const SelectOptions = ({
  name,
  values = [],
  multi = false,
}: SelectProps) => {
  const { setValue, watch } = useFormContext();
  const { errors } = useFormState({ name });

  const errorMessage: any = !!errors[name]?.message
    ? errors[name]?.message
    : '';

  const isError = !!errorMessage;

  const formValue: string | string[] = watch(name);

  const selectedValues = useMemo(() => {
    if (typeof formValue === 'string') {
      return [formValue];
    } else if (Array.isArray(formValue)) {
      return formValue;
    } else {
      return [];
    }
  }, [formValue]);

  const onSelectedValue = (value: string) => {
    let newValue: string[] | string = [...selectedValues];

    if (!!multi) {
      if (newValue.includes(value)) {
        newValue = newValue.filter(v => v !== value);
      } else {
        newValue.push(value);
      }
    } else {
      if (newValue.includes(value)) {
        newValue = '';
      } else {
        newValue = value;
      }
    }

    setValue(name, newValue);
  };

  return (
    <Box>
      {!!isError && (
        <Typography sx={{ marginBottom: '10px', color: 'red' }}>
          {errorMessage}
        </Typography>
      )}
      <Box
        style={{
          display: 'grid',
          gap: '16px',
          gridTemplateColumns: 'auto auto auto',
        }}
      >
        {values.map(value => (
          <SelectButton
            selected={selectedValues.some(v => v === value)}
            onClick={() => onSelectedValue(value)}
          >
            {value}
          </SelectButton>
        ))}
      </Box>
    </Box>
  );
};
